import { externalRedirect } from '@americanexpress/one-app-ducks';
// import { v4 as uuid } from 'uuid';
import { setUserProfile } from '../ducks';
import getLinks from '../utils/linksUtils';
import { checkUserIsEligible, parseResponse } from '../utils/utils';

export function checkUserStatus() {
  return (dispatch, getState, { fetchClient }) => {
    const oneDataApiUrl = getState().getIn(['config', 'oneDataApiUrl']);
    // const corelationId = uuid();
    const correlationId = getState().getIn(['modules', 'axp-commercial-reconciliation-root', 'correlationId']);
    const options = {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'one-data-correlation-id': correlationId,
      },
    };
    return fetchClient(`${oneDataApiUrl}/ReadReconUserProfile.v1`, options);
  };
}

const requireReconAuth = (
  { dispatch, getState }
) => async (nextState, replace, callback) => {
  const state = getState();
  const currentEnv = state.getIn(['config', 'linkKey']);
  const reconLinks = getLinks('recon', currentEnv);
  let statusCode = '';
  const redirect = () => {
    if (global.BROWSER) {
      switch (statusCode) {
        case 403:
          dispatch(externalRedirect(`${reconLinks.reconPortalAdvUrl}`));
          break;
        case 401:
          replace({ pathname: 'unauthorizedError' });
          break;
        default:
          replace({ pathname: 'error' });
          break;
      }
    }
  };

  try {
    const response = await dispatch(checkUserStatus());
    const { status } = response;
    statusCode = status;
    switch (status) {
      case 200: {
        const userDetails = await response.json();
        if (checkUserIsEligible(userDetails) === true) {
          const formattedObj = parseResponse(userDetails);
          await dispatch(setUserProfile(formattedObj));
        } else {
          replace({ pathname: 'unauthorizedError' });
        }
        break;
      }
      default: {
        redirect();
        break;
      }
    }
    callback();
  } catch (error) {
    redirect();
    callback();
  }
};

export default requireReconAuth;
